module.exports = __webpack_public_path__ + "static/media/circle@2x.43ac9ca5.png";